import { apiFetch } from './client';
import type {
  EstadoSolicitudAcceso,
  SolicitudAccesoAprobarPayload,
  SolicitudAccesoCreatePayload,
  SolicitudAccesoRead,
  SolicitudAccesoRechazarPayload,
} from './types';

export function crearSolicitudAcceso(
  payload: SolicitudAccesoCreatePayload,
): Promise<unknown> {
  return apiFetch<unknown>('/solicitudes-acceso/', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function listarSolicitudes(
  estado: EstadoSolicitudAcceso | 'todas' = 'pendiente',
): Promise<SolicitudAccesoRead[]> {
  const query = estado === 'todas' ? '?estado=' : `?estado=${estado}`;
  return apiFetch<SolicitudAccesoRead[]>(`/solicitudes-acceso/${query}`);
}

export function aprobarSolicitud(
  id: string,
  payload: SolicitudAccesoAprobarPayload,
): Promise<unknown> {
  return apiFetch<unknown>(`/solicitudes-acceso/${id}/aprobar`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function rechazarSolicitud(
  id: string,
  payload: SolicitudAccesoRechazarPayload,
): Promise<unknown> {
  return apiFetch<unknown>(`/solicitudes-acceso/${id}/rechazar`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
